import { createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../models/base';

export const fetchEnquiries = createAsyncThunk(
  'enquiries/fetchEnquiries',
  async (_, { rejectWithValue, getState }) => {
    const { pageNumber, perPage } = getState().enquiries;

    try {
      const response = await get(
        `/api/enquiries?page=${pageNumber}&per_page=${perPage}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
